// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3552":"6a6eaafa","3889":"6a6eaafa"}[chunkId] + ".chunk.css";
};